import { Cell, Grid } from 'bold-ui'
import { CheckboxField, FormDebouncedValueSpy, FormRenderProps, TextField } from 'components/form'
import { FormState } from 'final-form'
import { HistoricoPrescricaoQueryInput } from 'graphql/types.generated'
import React from 'react'
import { Form } from 'react-final-form'

export interface HistoricoPrescricaoTableFilterProps {
  initialValues?: HistoricoPrescricaoQueryInput
  onChange(values: HistoricoPrescricaoQueryInput): void
}

export default function HistoricoPrescricaoTableFilter(props: HistoricoPrescricaoTableFilterProps) {
  const { initialValues, onChange } = props

  const handleChange = (formState: FormState<HistoricoPrescricaoQueryInput>) => {
    props.onChange(formState.values)
  }

  const renderForm = (renderProps: FormRenderProps<HistoricoPrescricaoQueryInput>) => {
    return (
      <>
        <Grid alignItems='center' gap={1}>
          <FormDebouncedValueSpy onChange={handleChange} loadOnMount={false} />
          <Cell size={4}>
            <TextField name='query' placeholder='Pesquise por medicamento' icon='zoomOutline' />
          </Cell>
          <Cell size={6}>
            <CheckboxField name='usoContinuo' label='Ver apenas medicamentos de uso contínuo' />
          </Cell>
        </Grid>
      </>
    )
  }

  return <Form<HistoricoPrescricaoQueryInput> onSubmit={onChange} render={renderForm} initialValues={initialValues} />
}
